import z from 'zod';

import { getElementTypes } from '@@plate/utils/getElementTypes';

import { PlateTextElements, TextElementsCodec, UnityTextElements } from './Text';
import { CURRENT_VERSION, ElementId, UnityElementId, Version } from '../commons';
import { ELEMENT_TYPES, UNITY_ELEMENT_TYPES } from '../constants';

export const UnityParagraph = z.object({
    type: z.literal(UNITY_ELEMENT_TYPES.TEXT),
    elementId: UnityElementId,
    templateElement: z.boolean().optional(),
    version: Version,
    items: UnityTextElements,
});
export type UnityParagraph = z.infer<typeof UnityParagraph>;

export const PlateParagraph = z.object({
    type: z.literal(ELEMENT_TYPES.PARAGRAPH),
    // TODO: This should not be optional, it is the case for now because we use the old
    // `makeState` from Slate that doesn't set the id
    // By doing it this way, we losen Zod runtime validation, without letting the type error get ignored.
    id: ElementId.optional() as unknown as typeof ElementId,
    data: z
        .object({
            templateElement: z.boolean().optional(),
        })
        .optional(),
    children: PlateTextElements,
});
export type ParagraphElement = z.infer<typeof PlateParagraph>;

export const PARAGRAPH_ELEMENT_TYPES = getElementTypes([PlateParagraph]);

export const ParagraphCodec = z.codec(UnityParagraph, PlateParagraph, {
    decode: (value) => ({
        type: ELEMENT_TYPES.PARAGRAPH,
        id: value.elementId ?? crypto.randomUUID(),
        ...(value.templateElement ? { data: { templateElement: value.templateElement } } : {}),
        children: TextElementsCodec.decode(value.items),
    }),
    encode: (value) => ({
        type: UNITY_ELEMENT_TYPES.TEXT,
        // TODO: We shouldn't need the fallback, see comment on `id` in the `PlateParagraph` schema
        elementId: value.id ?? crypto.randomUUID(),
        version: CURRENT_VERSION,
        items: TextElementsCodec.encode(value.children),
        ...value.data,
    }),
});
